import { useRef, useState } from "react";

interface EmailBodyProps {
    html?: string;
    text?: string;
}

function EmailBody({ html, text }: EmailBodyProps) {
    let iframeRef = useRef<HTMLIFrameElement>(null);
    let [height, setHeight] = useState(0);

    function handleLoad() {
        let body = iframeRef.current?.contentWindow?.document.body;
        if (body) {
            setHeight(body.scrollHeight);
        }
    }

    if (html) {
        return (
            <iframe
                ref={iframeRef}
                className={"emailBodyFrame"}
                title={"Email body"}
                sandbox={"allow-same-origin"}
                srcDoc={html}
                onLoad={handleLoad}
                style={{ height: height }}
            />
        );
    }

    if (text) {
        return <div className={"textEmail"}>{text}</div>;
    }

    return null;
}

export default EmailBody;
